import {
  GET_BM_REPORT,
  GET_CM_REPORT,
  GET_CONVERSION_FUNNEL_REPORT,
  GET_CT_REPORT,
  GET_PDR_REPORT,
  GET_REPORT_CPNAME_LIST,
  GET_REPORT_EMPLOYEE_LIST,
  GET_REPORT_PROPERTY_LIST,
  GET_SCM_REPORT,
  GET_SHCH_REPORT,
  GET_SM_REPORT,
  GET_SRCH_REPORT,
  GET_ST_REPORT,
  GET_TEAM_CP_PERFORMANCE_REPORT,
  GET_TEAM_PERFORMANCE_REPORT,
  MONTHLY_PROPERTY_REPORT,
  USER_ACTIVITY_REPORT,
} from "../types";
import strings from "translate/language";
import { errorToast } from "utils/httpClient";
import ReportService from "../service/Report";

export const getConversionFunnelReport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getConversionFunnelReport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_CONVERSION_FUNNEL_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_CONVERSION_FUNNEL_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};
export const getTeamPerformanceReport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getTeamPerformanceReport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_TEAM_PERFORMANCE_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_TEAM_PERFORMANCE_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};
export const getTeamCpPerformanceReport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getTeamCpPerformanceReport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_TEAM_CP_PERFORMANCE_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_TEAM_CP_PERFORMANCE_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};
export const getReportPropertyList = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getReportPropertyList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_REPORT_PROPERTY_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_REPORT_PROPERTY_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};
export const getReportEmployeeList = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getReportEmployeeList(item);
    if (res.data.status === 200) {
      dispatch({
        type:
          item.user_type === 1
            ? GET_REPORT_EMPLOYEE_LIST
            : GET_REPORT_CPNAME_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type:
          item.user_type === 1
            ? GET_REPORT_EMPLOYEE_LIST
            : GET_REPORT_CPNAME_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};


export const getMonthlyPropertyReport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getMonthlyPropertyReport(item);
    if (res.data.status === 200) {
      dispatch({
        type: MONTHLY_PROPERTY_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: MONTHLY_PROPERTY_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};
export const getUserActivityReport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getUserActivityReport(item);
    if (res.data.status === 200) {
      dispatch({
        type: USER_ACTIVITY_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: USER_ACTIVITY_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};

export const getPdrReport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getPdrReport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_PDR_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_PDR_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};

export const getSTreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getSTreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_ST_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_ST_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};

export const getCTreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getCTreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_CT_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_CT_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};


export const getCMreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getCMreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_CM_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_CM_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};


export const getSMreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getSMreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_SM_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SM_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};


export const getSCMreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getSCMreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_SCM_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SCM_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};

export const getSHCHreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getSHCHreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_SHCH_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SHCH_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};

export const getSrcHreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getSrcHreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_SRCH_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SRCH_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};

export const getBMreport = (item) => async (dispatch) => {
  try {
    const res = await ReportService.getBMreport(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_BM_REPORT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_BM_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data);
  }
};


